export interface IAddon {
  id?: number;
  name?: string;
  type?: string;
  value?: string;
  minValue?: number;
  maxValue?: number;
  monthlyStripeId?: string;
  yearlyStripeId?: string;
}

export class Addon implements IAddon {
  constructor(
    public id?: number,
    public name?: string,
    public type?: string,
    public value?: string,
    public minValue?: number,
    public maxValue?: number,
    public monthlyStripeId?: string,
    public yearlyStripeId?: string
  ) {}
}
